import { Routes } from 'constants/pages';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <div className="space-x-3 text-gray-100">
      <Link target="_blank" to={Routes.PrivacyPolicy}>
        Privacy & Terms
      </Link>
      <a href="mailto:contact@bluecargo.io" className="">
        Contact Us
      </a>
    </div>
  );
};
